import React from 'react';
import { PopperFieldEditorContentProps } from '../../../canvas/workspace/adapters/PopperFieldEditor';
import { JiraOAuthRequired } from './JiraOAuthRequired';

export type JiraCardFieldPopperContent = ({ field, onClose }: PopperFieldEditorContentProps) => JSX.Element;

export const JiraOAuthRequiredPopperContent = (Content: JiraCardFieldPopperContent): JiraCardFieldPopperContent =>
    ({ field, onClose }: PopperFieldEditorContentProps) => {
        return <JiraOAuthRequired onReject={onClose}>
            <Content {...{ field, onClose }} />
        </JiraOAuthRequired>;
    };
